import { Clipboard } from '@capacitor/clipboard'
import { useGate, useStore } from 'effector-react'
import { copyOutline } from 'ionicons/icons'
import { useState } from 'react'
import { Penalty } from '~/shared/api'
import { formatDateTimeForUI } from '~/shared/lib/date'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { IconButton } from '~/shared/ui/Buttons'
import { ImageSliderModal } from '~/shared/ui/ImageSliderModal'
import { ProgressBlock } from '~/shared/ui/Loaders'
import { useModal } from '~/shared/ui/Modal'
import { myPalette } from '~/shared/ui/theme'
import { $photos, fetchImageFx, Gate } from './model'
import { Field, ImgsWrapper, ImgWrapper, Title } from './styled'

type ContentProps = {
  penalty: Penalty
}

export function Content({ penalty }: ContentProps) {
  useGate(Gate, penalty)
  const [selectedPhotoId, setSelectedPhotoId] = useState<UniqueId>()
  const { isModalShow, openModal, closeModal } = useModal()

  const photos = useStore($photos) || []
  const isPhotosLoading = useStore(fetchImageFx.pending)

  const handleSliderModalShow = (photoId: UniqueId) => {
    setSelectedPhotoId(photoId)
    openModal()
  }

  const handleDescriptionCopy = async () => {
    await Clipboard.write({
      string: penalty.getProtocolNumber(),
    })
    snackbarEnqueued({
      message: 'Номер протокола скопирован в буфер обмена',
      variant: 'secondary',
    })
  }

  return (
    <>
      {penalty && (
        <>
          {isPhotosLoading && !photos?.length && <ProgressBlock height={175} />}

          {!isPhotosLoading && !photos?.length && <Field>Фотографий нет</Field>}

          {!!photos?.length && (
            <ImgsWrapper>
              {photos.map((photo) => (
                <ImgWrapper
                  key={photo.id}
                  onClick={() => handleSliderModalShow(photo.id)}
                >
                  <img
                    src={photo.src}
                    width='100%'
                    height='auto'
                    alt='Фотография штрафа'
                  />
                </ImgWrapper>
              ))}
            </ImgsWrapper>
          )}

          <Title>
            {penalty.getPenaltyLawArticleNumber()} -{' '}
            {penalty.getPenaltyLawArticleDescription()}
          </Title>
          <Field>{formatDateTimeForUI(penalty.getProtocolDate())}</Field>
          <Field style={{ display: 'flex', alignItems: 'center' }}>
            {penalty.getProtocolNumber()}
            <IconButton
              onClick={handleDescriptionCopy}
              icon={copyOutline}
              iconProps={{
                style: { color: myPalette.midnightBlue.main, width: '20px' },
              }}
              variant='outline'
            />
          </Field>
          <Field>{penalty.getCarVin()}</Field>
          <Field>{penalty.getOdpsName()}</Field>
          <Field>{penalty.getPenaltyLocation()}</Field>
        </>
      )}

      <ImageSliderModal
        images={photos}
        isShow={isModalShow}
        onClose={closeModal}
        visibleImageId={selectedPhotoId}
      />
    </>
  )
}
